import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const campainCreate = (data: any, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: "/campaigns",
    data: {
      ...data,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const getCampaigns = (params: any, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: "/campaigns",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const getCampaignDetails = (campaignId: any) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/campaigns/${campaignId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editCampaign = (campaignId: any, data: any) => {
  const token = getAuthToken();
  return axios({
    method: "PUT",
    url: `/campaigns/${campaignId}`,
    data: {
      ...data,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const taskCreate = (data: any, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: "/task",
    data: {
      ...data,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const getTasks = (params: any, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: "/task",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const editTask = (taskId: any, data: any) => {
  const token = getAuthToken();
  return axios({
    method: "PUT",
    url: `/task/${taskId}`,
    data: {
      ...data,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const deleteTask = (taskId: number) => {
  const token = getAuthToken();
  return axios({
    method: "Delete",
    url: `/task/${taskId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getTaskById = (
  taskId: number,
  campaignId?: number,
  moduleName?: string
) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/task/${taskId}`,
    params: campaignId ? { campaignId } : {},
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName || "",
    },
  });
};

export const addCampaignAttachment = (campaignId: number, data: any) => {
  return axios({
    method: "POST",
    url: `/campaigns/${campaignId}/attachment`,
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    timeout: 10 * 60 * 1000,
  });
};

export const getAttachments = (campaignId: number) => {
  return axios({
    method: "GET",
    url: `/campaigns/${campaignId}/attachments`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addCampaignLinkAttachment = (campaignId: number, data: any) => {
  return axios({
    method: "PUT",
    url: `/campaigns/${campaignId}/attachment-link`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteCampaignAttachment = (
  campaignId: number,
  attachmentId: number
) => {
  return axios({
    method: "Delete",
    url: `/campaigns/${campaignId}/attachments/${attachmentId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const createMeeting = (data: any, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: "/meeting",
    data: {
      ...data,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const getMeetings = (params: any, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: "/meeting",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const editMeeting = (meetingId: any, data: any) => {
  const token = getAuthToken();
  return axios({
    method: "PUT",
    url: `/meeting/${meetingId}`,
    data: {
      ...data,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const deleteMeeting = (meetingId: number) => {
  const token = getAuthToken();
  return axios({
    method: "Delete",
    url: `/meeting/${meetingId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getMeetingById = (
  meetingId: number,
  campaignId?: number,
  moduleName?: string
) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/meeting/${meetingId}`,
    params: campaignId ? { campaignId } : {},
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName || "",
    },
  });
};

export const massDeleteOfCampaigns = (data: { campaignIds: number[] }) => {
  const url = "campaigns/massDelete";
  return axios({
    method: "Delete",
    url: url,
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const massUpdateOfCampaigns = (data: {
  campaignIds: number[];
  fieldToUpdate: any;
}) => {
  const url = "campaigns/massUpdate";
  return axios({
    method: "PUT",
    url: url,
    data: {
      ...data,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const exportCampaigns = (format: string, campaignIds: number[]) => {
  return axios({
    method: "POST",
    url: `/campaigns/export?format=${format}`,
    data: { campaignIds },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
export const createEmail = (data: unknown, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: "/email",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const getEmails = (params: any, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: "/email",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const deleteEmail = (emailId: number) => {
  const token = getAuthToken();
  return axios({
    method: "Delete",
    url: `/email/${emailId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getEmailById = (
  emailId: number,
  campaignId?: number,
  moduleName?: string
) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/email/${emailId}`,
    params: campaignId ? { campaignId } : {},
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName || "",
    },
  });
};

export const getCampaignPerformanceMetrics = (params: any) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: "/campaigns/metrics",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const exportMetricCampaigns = (params: any, data?: any) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: "/campaigns/metrics/export",
    params,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCallById = (
  callId: number,
  campaignId?: number,
  moduleName?: string
) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/calls/${callId}`,
    params: campaignId ? { campaignId } : {},
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName || "",
    },
  });
};

export const getCalls = (params: any, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: "/calls",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};

export const editCall = (callId: any, data: any) => {
  const token = getAuthToken();
  return axios({
    method: "PUT",
    url: `/calls/${callId}`,
    data: {
      ...data,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAssignedPeopleList = (campaignId: number) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/campaigns/${campaignId}/assigned-entities`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createCall = (data: any) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: `/calls`,
    data: {
      ...data,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteCall = (callId: number) => {
  const token = getAuthToken();
  return axios({
    method: "Delete",
    url: `/calls/${callId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const campainAssignToCustomers = (
  data: {
    customerIds: number[];
    campaignId: number;
    customerStatusInCampaign: string;
  },
  moduleName?: string
) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: `/campaigns/addToCampaigns`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};

export const editCampaignStatus = (
  status: string,
  resourceIds: number[],
  moduleName?: string
) => {
  const url = `/campaigns/update/memberStatus`;
  return axios.put(
    url,
    {
      status,
      resourceIds,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-source-module": moduleName,
      },
    }
  );
};

export const deleteCampaignAssign = (
  customerId: number,
  campaignCustomerAssociationId: number,
  moduleName?: string
) => {
  const url = `/campaigns/${customerId}/campaign-associations/${campaignCustomerAssociationId}`;
  return axios.delete(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};

export const fetchOverDueCallsWithLeadId = (leadId: number) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    params: { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
    url: `/leads/${leadId}/overdue-calls`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchLandingPageDetails = () => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/campaigns/landing-pages`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchOverDueCallsWithCustomerId = (customerId: number) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    params: { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
    url: `/customers/${customerId}/overdue-calls`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const saveLandingPageDetails = (data: any) => {
  const token = getAuthToken();
  return axios({
    method: "PUT",
    url: `/campaigns/landing-pages`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const shareLandingPage = (data: any) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: `/campaigns/landing-pages/share`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const uploadImageToS3 = (data: any) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: `/campaigns/landing-pages/images/upload`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};
export const getLetters = (
  params: any,
  moduleName?: string,
  letterId?: number
) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/letter${letterId ? `/${letterId}` : ""}`,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};

export const createLetter = (data: any, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: "/letter",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};

export const deleteLetter = (letterId: number) => {
  const token = getAuthToken();
  return axios({
    method: "Delete",
    url: `/letter/${letterId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editLetter = (
  letterId: number,
  data: any,
  moduleName?: string
) => {
  const token = getAuthToken();
  return axios({
    method: "PUT",
    url: `/letter/${letterId}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};

export const getCampaignEmails = (params: any) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/email`,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const sendCampaignEmails = (data: any) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: `/email/campaign-email`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export const sendCampaignSMS = (campaignId: number, data: any) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: `/campaigns/${campaignId}/sendSms`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getEachCampaignEmailDetails = (emailId: number) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/email/campaign-email/${emailId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}